export const participationEvents = [
  {
    id: "kbct-puja-aarti",
    shortLabel: "KBCT Puja & Aarti",
    label:
      "Fri, 10th July 2026, 09:00 AM to 10:30 AM - Puja & Aarti at KBCT Arogya Bhavan",
  },
  {
    id: "kbct-satsang",
    shortLabel: "KBCT Satsang",
    label:
      "Fri, 10th July 2026, 10:30 AM to 11:30 AM - Satsang at KBCT Arogya Bhavan",
  },
  {
    id: "kbct-inauguration",
    shortLabel: "KBCT Inauguration",
    label:
      "Fri, 10th July 2026, 11:30 AM to 01:00 PM - Renovated KBCT Arogya Bhavan Inauguration",
  },
  {
    id: "goda-aarti",
    shortLabel: "Goda Aarti",
    label: "Fri, 10th July 2026, 06:00 PM to 07:30 PM - Goda Aarti",
  },
  {
    id: "karaoke-night",
    shortLabel: "Karaoke Night",
    label:
      "Fri, 10th July 2026, 07:30 PM to 09:00 PM - Karaoke Night (Singing Participation)",
  },
  {
    id: "heritage-walk",
    shortLabel: "Heritage Walk",
    label: "Sat, 11th July 2026, 06:00 AM to 08:00 AM - Heritage Walk",
  },
];

export const getDefaultParticipationEventsMap = () =>
  Object.fromEntries(participationEvents.map((event) => [event.id, false]));

export const normalizeParticipationEventsMap = (events) => {
  const result = getDefaultParticipationEventsMap();
  if (!events) return result;

  if (Array.isArray(events)) {
    events.forEach((event) => {
      const id = typeof event === "string" ? event : event?.id;
      if (id && Object.prototype.hasOwnProperty.call(result, id)) {
        result[id] = true;
      }
    });
    return result;
  }

  participationEvents.forEach((event) => {
    if (events[event.id] === true) {
      result[event.id] = true;
    }
  });

  return result;
};

export const getSelectedParticipationEvents = (events) => {
  const eventMap = normalizeParticipationEventsMap(events);
  return participationEvents.filter((event) => eventMap[event.id]);
};

export const normalizeParticipationEvents = getSelectedParticipationEvents;

export const formatParticipationEventsForExport = (events) =>
  getSelectedParticipationEvents(events)
    .map((event) => event.label)
    .join(" | ");

export const getParticipationEventsExportColumns = (events) => {
  const eventMap = normalizeParticipationEventsMap(events);
  return Object.fromEntries(
    participationEvents.map((event) => [
      event.id,
      eventMap[event.id] ? "Yes" : "No",
    ]),
  );
};
